let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1D6DH"), load("f7nCb")]).then(() => parcelRequire('4xvKn'));